import { render, staticRenderFns } from "./FirmwareTypeManagement.vue?vue&type=template&id=6b39229b&scoped=true"
import script from "./FirmwareTypeManagement.vue?vue&type=script&lang=js"
export * from "./FirmwareTypeManagement.vue?vue&type=script&lang=js"
import style0 from "./FirmwareTypeManagement.vue?vue&type=style&index=0&id=6b39229b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b39229b",
  null
  
)

export default component.exports